import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-style-guide';
import scrollIntoView from '../utilities/scrollIntoView';

function GetPremiumButton({ translate, ...otherProps }) {
  return (
    <Button
      className='get-premium-button'
      variant={Button.variants.primary}
      width={Button.widths.min}
      onClick={() => scrollIntoView('premium-memberships')}
      {...otherProps}>
      {translate('Action.GetPremium')}
    </Button>
  );
}

GetPremiumButton.defaultProps = {
  size: Button.sizes.large
};

GetPremiumButton.propTypes = {
  translate: PropTypes.func.isRequired,
  size: PropTypes.string
};

export default GetPremiumButton;
